import Image from 'next/image';
import Link from 'next/link';

const STORE_LINKS = [
  {
    href: 'https://apps.apple.com/us/app/sk-club-frikd-up-fishies/id6755168106',
    badge: '/badges/app-store-badge.svg',
    alt: 'Download on the App Store',
  },
  {
    href: 'https://play.google.com/store/apps/details?id=com.minnerlabs.FrikdUpFishies',
    badge: '/badges/google-play-badge.svg',
    alt: 'Get it on Google Play',
  },
];

const TANK_BACKGROUND = 'radial-gradient(circle at 50% 35%, #12485a 0%, #0c2a3b 60%, #091a29 100%)';

const HomeHeroSKClub = () => (
  <div className='bg-gray-900 overflow-hidden border-b border-gray-800'>
    <div className='grid lg:grid-cols-2 gap-12 lg:gap-16 items-center px-4 mx-auto lg:px-8 max-w-7xl py-12 md:py-20'>
      <div className='flex flex-col items-start gap-6 md:gap-8'>
        <div className='w-[240px] md:w-[400px]'>
          <Image src='/sk-club/sk-club-horizontal.png' alt='SK Club' width={2014} height={433} priority />
        </div>
        <h1 className='text-4xl font-extrabold text-neutral-50 md:text-6xl tracking-tight [text-wrap:balance]'>
          Games &amp; Mobile Apps by <span className='text-primary-500'>Shitty&nbsp;Kitties</span>
        </h1>
        <p className='text-lg md:text-2xl text-neutral-300 max-w-lg [text-wrap:balance]'>Some chill &amp; cozy, some chaotic, all uniquely&nbsp;Shitty.</p>
        <div className='flex flex-wrap items-center gap-4'>
          {STORE_LINKS.map(({ href, badge, alt }) => (
            <a key={href} href={href} target='_blank' rel='noopener noreferrer' className='hover:opacity-80 transition-opacity'>
              <img src={badge} alt={alt} className='h-[52px] w-auto' />
            </a>
          ))}
          <Link href='/sk-club'>
            <a className='flex items-center h-[52px] px-2 text-primary-500 hover:text-primary-300 font-bold text-lg underline underline-offset-4'>
              Explore SK Club
            </a>
          </Link>
        </div>
      </div>

      <div className='relative w-full max-w-[520px] mx-auto lg:mr-0'>
        <Link href='/sk-club/frikd-up-fishies'>
          <a
            className='flex flex-col items-center justify-center gap-4 md:gap-6 aspect-square rounded-[28px] md:rounded-[36px] p-8 md:p-14 text-center'
            style={{ background: TANK_BACKGROUND }}
          >
            <div className='w-full max-w-[400px]'>
              <Image src='/sk-club/logo-frikd.png' alt="Frik'd Up Fishies" width={500} height={339} priority />
            </div>
            <p className='text-lg md:text-[22px] font-extrabold leading-snug text-white'>
              Kitties taking care of fish.
              <br />
              What could go wrong?
            </p>
            <p className='text-sm font-semibold text-primary-200'>Available now on iOS and Android</p>
          </a>
        </Link>
        <div className='hidden md:block absolute -left-20 top-2 w-40 pointer-events-none'>
          <Image src='/sk-club/og-assets/blue-tang.png' alt='' width={800} height={800} priority />
        </div>
        <div className='absolute -right-2 md:-right-10 -bottom-2 md:bottom-6 w-28 md:w-44 pointer-events-none'>
          <Image src='/sk-club/og-assets/clownfish.png' alt='' width={800} height={800} priority />
        </div>
      </div>
    </div>
  </div>
);

export default HomeHeroSKClub;
